module.exports = __webpack_public_path__ + "img/voodoo_banner.8e2cf6e8.jpeg";